class SEPADataSource extends MIOObject
{
    private filterHeader:MUIView = null;

    private venueTextField:ColumnFilterTextField = null;
    private categoryTextField:ColumnFilterTextField = null;
    private productTextField:ColumnFilterTextField = null;

    private tableView:UITableView = null;
        
    private formatFilterHeader:UIScrollView = null;
    private formatTableView:UITableView = null;    

    private filterController:ColumnFilterController = null;

    private owner: AccountingEntryDelegate
    
    initWithTableView(tableView:UITableView, filterHeader:MUIView, owner:AccountingEntryDelegate){
        this.filterHeader = filterHeader;
        this.tableView = tableView;
        this.owner = owner;
        
        // this.tableView.dataSource = this;
        // this.tableView.delegate = this;
        
        // this.formatTableView = formatTableView;
        // this.formatFilterHeader = formatHeader;
        // this.formatTableView.dataSource = this;
        // this.formatTableView.delegate = this;

        // this.filterController = new ColumnFilterController();
        // this.filterController.initWithDelegate(this);

        // this.venueTextField = MUIOutlet(owner, "format-venue-filter-tf", "ColumnFilterTextField");
        // this.venueTextField.filterController = this.filterController;
		// this.venueTextField.setOnFilterChange(ColumnFilterTextFieldType.String, "venueName", null, null);

        // this.categoryTextField = MUIOutlet(owner, "format-category-filter-tf", "ColumnFilterTextField");
        // this.categoryTextField.filterController = this.filterController;
		// this.categoryTextField.setOnFilterChange(ColumnFilterTextFieldType.String, "categoryName", null, null);

        // this.productTextField = MUIOutlet(owner, "format-product-filter-tf", "ColumnFilterTextField");
        // this.productTextField.filterController = this.filterController;
		// this.productTextField.setOnFilterChange(ColumnFilterTextFieldType.String, "productName", null, null);

        // let tf = MUIOutlet(owner, "titlebar-tf", "MUILabel");
        // tf.hidden = true;
    }    

    reloadData(){  
        this.filterHeader.hidden = false;
        this.tableView.dataSource = this;
        this.tableView.delegate = this as any;

        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    numberOfSections(tableView:UITableView){
        return this.fetchedResultsController.sections.length;        
    }
    
    numberOfRowsInSection(tableView:UITableView, section:number){        
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();        
    }

    // titleForHeaderInSection(tableView:UITableView, section:number) {
        // let ip = MIOIndexPath.indexForRowInSection(0, section);
        // let item = this.fetchedResultsController.objectAtIndexPath(ip) as ProductComponentItem;
//        let item = this.product_formats[indexPath.row];
        //return item.categoryName;
    //}

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let item = this.fetchedResultsController.objectAtIndexPath( indexPath ) as BankTransferBundleFile;
        let cell = tableview.dequeueReusableCellWithIdentifier("SEPACell") as SEPACell;
                
        cell.item = item;
        cell.delegate = this.owner;

        return cell;
    }


    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null) return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;
                
        let sds = [ MIOSortDescriptor.sortDescriptorWithKey("referenceDateString", true),
                    //MIOSortDescriptor.sortDescriptorWithKey("productFormat.product.category.name", true),
                    //MIOSortDescriptor.sortDescriptorWithKey("productFormat.product.name", true)
                    ];
        
        let predicateFormat = null; //"deletedAt = null && placeID != '" + ad.selectedIdentifier + "' && productFormat.product.category != null"
        // let filterPredicateFormat = this.filterController.filterPredicateFormat();
        // if (filterPredicateFormat != null){
        //     predicateFormat += " AND (" + filterPredicateFormat + ")";
        // }            

        let fetchRequest = DBHelper.listFetchRequestWithEntityName("BankTransferBundleFile", sds, predicateFormat);
        // fetchRequest.relationshipKeyPathsForPrefetching = [ "productFormat.product", "productFormat.format", "productFormat.product.category" ];
        //fetchRequest.fetchLimit = 500;

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;

        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller){
        this.tableView.reloadData();
    }
    
    filterPredicateDidChange(controller:ColumnFilterController){
        let pf = this.filterController.filterPredicateFormat();
    }
}
